import { create } from 'zustand'
export const useGetScheduleShipmentsStore = create(set => ({
  dateExpiryStart: null,
  setDateExpiryStart: dateExpiryStart => set(() => ({ dateExpiryStart })),
  dateExpiryEnd: null,
  setDateExpiryEnd: dateExpiryEnd => set(() => ({ dateExpiryEnd })),
  scheduledShipmentsData: [],
  setScheduledShipmentsData: scheduledShipmentsData =>
    set(() => ({ scheduledShipmentsData })),
  resetStore: () =>
    set(() => ({
      dateExpiryStart: null,
      dateExpiryEnd: null,
      scheduledShipmentsData: [],
    })),
}))
